<div class="modal-container">
  <div class="modal-header">
    <input ngbAutofocus class="no-size" />
    <span class="modal-title">{{ title }}</span>
    @if (allowHeaderDismiss) {
      <grid-ui-icon
        type="button"
        class="mc-dismiss-icon close-icon"
        aria-label="Dismiss"
        (click)="dismiss()"
        ngbTooltip="Close window"
        name="cross"
        data-testid="icon-close-modal"
      >
      </grid-ui-icon>
    }
  </div>

  <div class="modal-body p-4">
    <div class="align-items-center d-flex flex-column justify-content-center">
      @if (isProcessing) {
        <span class="mc-processing mt-4 mb-5">
          <i class="fas fa-spinner fa-4x fa-spin"></i>
        </span>
      }

      @if (responseState === ActionResponseState.Success) {
        <span class="mc-success">
          <i class="fas fa-check-circle fa-4x"></i>
        </span>
      }

      @if (responseState === ActionResponseState.Info || hasFailed) {
        <span
          class="d-flex flex-column justify-content-center align-items-center"
          [class.mc-info]="!warning && !hasFailed"
          [class.mc-failure]="warning || hasFailed"
        >
          <i class="fas fa-exclamation-circle fa-4x"></i>
          @if (hasFailed) {
            <h2 class="mt-4 mb-4">Sorry, something went wrong.</h2>
          }
        </span>
      }

      <h3 class="mc-message center" [attr.data-hook]="'asm-modal-' + responseState + '-message'">
        {{ message }}
      </h3>

      @if (subMessage) {
        <p class="center mt-2">
          {{ subMessage }}
        </p>
      }

      <div class="d-flex">
        @if (allowSecondaryButton) {
          <button
            class="btn mc-btn-secondary mt-4 mb-1 me-3"
            (click)="closeSecondary()"
            [attr.data-testid]="'btn-' + (hasFailedOrSucceeded ? 'Close' : secondaryButtonLabel) | slugify"
          >
            {{ hasFailedOrSucceeded ? 'Close' : secondaryButtonLabel }}
          </button>
        }

        @if (buttonLabel && buttonLabel!.length > 0) {
          <button
            type="button"
            class="mc-close-button btn mt-4 mb-1"
            [class.mc-btn-danger]="warning"
            [class.mc-btn-primary]="!warning"
            [class.disabled]="isProcessing || (hasFailedOrSucceeded && allowSecondaryButton)"
            [attr.disabled]="isProcessing || (hasFailedOrSucceeded && allowSecondaryButton) || null"
            (click)="close()"
            [attr.data-testid]="'btn-' + buttonLabel | slugify"
          >
            {{ buttonLabel }}
          </button>
        }
      </div>
    </div>
  </div>

  @if (messageDetail) {
    <div class="modal-footer">
      <p class="mc-message-detail center">
        <span class="small">{{ messageDetail }}</span>
      </p>
    </div>
  }
</div>
